module.exports = __webpack_public_path__ + "img/garage_thumb.2f9b318c.jpg";